<template>
<div>
    <div class="grid xs-grid-cols-1 gap-3">
        <div class="inline bg-default corner large">
            <mvtHotleadForm :options="hotleadOpt"></mvtHotleadForm>
        </div>
        <div class="inline corner large flex wrap center bg-default">
            <div class="f4">
                Questions? Chat with your personal concierge
            </div>
            <a :href="'tel:' + getPhoneNumber" class="btn secondary regular"><i class="icon-phone"></i> Call Concierge</a>
        </div>
    </div>
</div>
</template>
<script src="./agent-connect.js"></script>
<style lang="scss">
@use "./agent-connect.scss" as *;
</style>